<template>
  <div
    class="container-fluid mt-3 mt-md-4 lista-compra-page"
    :class="{ 'lista-compra-page--compact': compacta }"
  >
    <div class="lista-compra-cabecera d-flex align-items-start justify-content-between mb-3 flex-wrap gap-2">
      <div class="min-w-0">
        <h2 class="mb-0 lista-compra-titulo">
          <i class="bi bi-cart3 me-2"></i>Lista de la compra
        </h2>
        <small class="text-muted lista-compra-extra">
          Compartida: lo que tacha uno lo ve el otro al momento
        </small>
      </div>
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <button
          v-if="puedeDeshacer"
          type="button"
          class="lista-undo-cabecera"
          :disabled="deshaciendo"
          :title="ultimaAccion ? `Deshacer ${ultimaAccion}` : 'Deshacer última acción'"
          @click="deshacer"
        >
          <span v-if="deshaciendo" class="spinner-border spinner-border-sm"></span>
          <i v-else class="bi bi-arrow-counterclockwise"></i>
          <span>Deshacer</span>
        </button>
        <button
          type="button"
          class="lista-compacta-toggle d-md-none"
          :class="{ 'lista-compacta-toggle--on': compacta }"
          :aria-pressed="compacta.toString()"
          @click="alternarCompacta"
        >
          <i class="bi" :class="compacta ? 'bi-arrows-expand' : 'bi-arrows-collapse'"></i>
          Compacta
        </button>
        <router-link class="btn btn-success btn-sm lista-ver-menu lista-compra-extra" to="/nutricion?from=lista">
          <i class="bi bi-egg-fried me-1"></i>Ver menú
        </router-link>
        <span class="badge rounded-pill lista-compra-extra" :class="pendientes ? 'bg-success' : 'bg-secondary'">
          {{ pendientes }} pendientes
        </span>
        <span class="sync-pill lista-compra-extra" :class="{ 'sync-pill--live': sincronizado }">
          <i class="bi" :class="sincronizado ? 'bi-broadcast' : 'bi-hourglass-split'"></i>
          {{ textoSync }}
        </span>
      </div>
    </div>

    <form class="lista-compra-add mb-3" @submit.prevent="anadirItem">
      <div class="lista-compra-add-wrap">
        <div class="input-group input-group-lg">
          <input
            v-model="nuevoNombre"
            type="text"
            class="form-control"
            placeholder="Añadir (leche, papel, lo que falte…)"
            maxlength="180"
            autocomplete="off"
            enterkeyhint="done"
            aria-autocomplete="list"
            aria-controls="compra-sugerencias"
            :aria-expanded="panelSugerencias.toString()"
            @input="onInputNuevo"
            @focus="onFocusNuevo"
            @keydown="onKeydownNuevo"
            @blur="cerrarSugerenciasLuego"
          />
          <button class="btn btn-success" type="submit" :disabled="!nuevoNombre.trim() || guardando">
            <i class="bi bi-plus-lg"></i>
            <span class="d-none d-sm-inline ms-1">Añadir</span>
          </button>
        </div>
        <ul
          v-if="panelSugerencias"
          id="compra-sugerencias"
          class="list-group lista-compra-sugerencias shadow"
          role="listbox"
        >
          <li
            v-for="(sug, idx) in sugerenciasVisibles"
            :key="sug.nombre"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            :class="{ active: idx === indiceSugerencia }"
            role="option"
            :aria-selected="idx === indiceSugerencia"
            @mousedown.prevent="elegirSugerencia(sug)"
          >
            <span>
              <i
                class="bi me-2 opacity-75"
                :class="sug.origen === 'menu' ? 'bi-egg-fried' : (sug.origen === 'fijo' ? 'bi-pin-angle' : 'bi-pencil')"
              ></i>{{ sug.nombre }}
            </span>
            <small :class="idx === indiceSugerencia ? 'text-white-50' : 'text-muted'">
              {{ sug.veces }}×
            </small>
          </li>
          <li v-if="!sugerenciasVisibles.length && !sugCargando" class="list-group-item text-muted small">
            <template v-if="nuevoNombre.trim()">
              Sin coincidencias. Pulsa Añadir para crear «{{ nuevoNombre.trim() }}».
            </template>
            <template v-else>
              Empieza a escribir: te sugerimos lo que ya habéis comprado.
            </template>
          </li>
        </ul>
      </div>
    </form>

    <div class="lista-siempre card border-0 mb-3 lista-compra-extra">
      <button
        type="button"
        class="lista-siempre-toggle"
        :aria-expanded="mostrarFijos.toString()"
        @click="mostrarFijos = !mostrarFijos"
      >
        <span>
          <i class="bi bi-pin-angle me-1"></i>Siempre
          <span class="badge rounded-pill bg-light text-dark ms-1">{{ fijos.length }}</span>
        </span>
        <i class="bi" :class="mostrarFijos ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </button>
      <div v-if="mostrarFijos" class="lista-siempre-body">
        <p class="small text-muted mb-2">
          Lista fija: se añade sola cada vez que generas la compra de la semana.
        </p>
        <form class="input-group input-group-sm mb-2" @submit.prevent="anadirFijo">
          <input
            v-model="nuevoFijo"
            type="text"
            class="form-control"
            placeholder="Leche, plátanos, papel…"
            maxlength="180"
          />
          <button class="btn btn-outline-success" type="submit" :disabled="!nuevoFijo.trim() || guardandoFijo">
            Añadir
          </button>
        </form>
        <ul v-if="fijos.length" class="lista-siempre-lista">
          <li v-for="fijo in fijos" :key="fijo.id">
            <input
              class="form-control form-control-sm"
              :value="fijo.nombre"
              @change="renombrarFijo(fijo, $event.target.value)"
            />
            <button type="button" class="lista-compra-borrar" title="Quitar de siempre" @click="borrarFijo(fijo)">
              <i class="bi bi-x-lg"></i>
            </button>
          </li>
        </ul>
        <p v-else class="small text-muted mb-0">Aún no hay ítems fijos.</p>
      </div>
    </div>

    <div class="lista-siempre lista-despensa card border-0 mb-3 lista-compra-extra">
      <button
        type="button"
        class="lista-siempre-toggle"
        :aria-expanded="mostrarDespensa.toString()"
        @click="mostrarDespensa = !mostrarDespensa"
      >
        <span>
          <i class="bi bi-archive me-1"></i>Despensa
          <span class="badge rounded-pill bg-light text-dark ms-1">{{ despensa.length }}</span>
        </span>
        <i class="bi" :class="mostrarDespensa ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </button>
      <div v-if="mostrarDespensa" class="lista-siempre-body">
        <p class="small text-muted mb-2">
          No se añade del menú. Úsalo para especias, botes y lo que compras solo cuando se acaba.
        </p>
        <form class="input-group input-group-sm mb-2" @submit.prevent="anadirDespensa">
          <input
            v-model="nuevaDespensa"
            type="text"
            class="form-control"
            placeholder="Comino, vinagre, aceite…"
            maxlength="180"
          />
          <button class="btn btn-outline-secondary" type="submit" :disabled="!nuevaDespensa.trim() || guardandoDespensa">
            Añadir
          </button>
        </form>
        <ul v-if="despensa.length" class="lista-siempre-lista">
          <li v-for="item in despensa" :key="item.id">
            <input
              class="form-control form-control-sm"
              :value="item.nombre"
              @change="renombrarDespensa(item, $event.target.value)"
            />
            <button type="button" class="lista-compra-borrar" title="Quitar de despensa" @click="borrarDespensa(item)">
              <i class="bi bi-x-lg"></i>
            </button>
          </li>
        </ul>
        <p v-else class="small text-muted mb-0">
          Las especias (comino, orégano, canela…) ya se saltan solas. Añade aquí el resto.
        </p>
      </div>
    </div>

    <div class="d-flex gap-2 flex-wrap mb-3 lista-compra-extra">
      <button
        class="btn btn-outline-success btn-sm"
        type="button"
        :disabled="generando"
        @click="pedirConfirmacion('anadirMenu')"
      >
        <span v-if="generando" class="spinner-border spinner-border-sm me-1"></span>
        <i v-else class="bi bi-egg-fried me-1"></i>
        Añadir del menú
      </button>
      <button
        class="btn btn-outline-secondary btn-sm"
        type="button"
        :disabled="generando"
        @click="pedirConfirmacion('regenerarMenu')"
      >
        <i class="bi bi-arrow-repeat me-1"></i>
        Regenerar menú
      </button>
      <button
        class="btn btn-outline-secondary btn-sm"
        type="button"
        :disabled="!tachados.length || limpiando"
        @click="pedirConfirmacion('limpiar')"
      >
        <i class="bi bi-trash3 me-1"></i>
        Quitar tachados
      </button>
      <button
        class="btn btn-outline-secondary btn-sm"
        type="button"
        :disabled="!tachados.length"
        @click="pedirConfirmacion('destachar')"
      >
        <i class="bi bi-arrow-counterclockwise me-1"></i>
        Destachar
      </button>
    </div>

    <div v-if="aviso" class="alert alert-success py-2 small">{{ aviso }}</div>
    <div v-if="sinIngredientes.length" class="alert alert-warning py-2 small">
      <i class="bi bi-info-circle me-1"></i>
      Sin receta en el recetario; no se añadieron: {{ sinIngredientes.join(', ') }}
    </div>
    <div v-if="omitidos.length" class="alert alert-light border py-2 small">
      <i class="bi bi-slash-circle me-1"></i>
      No se compran (restos o fuera): {{ omitidos.join(', ') }}
    </div>
    <div v-if="omitidosDespensa.length" class="alert alert-light border py-2 small">
      <i class="bi bi-archive me-1"></i>
      Especias y despensa (no se añaden cada semana): {{ omitidosDespensa.join(', ') }}
    </div>
    <div v-if="error" class="alert alert-danger py-2">
      <i class="bi bi-exclamation-triangle me-2"></i>{{ error }}
    </div>

    <div v-if="cargando && !items.length" class="text-center py-5">
      <div class="spinner-border text-success"></div>
      <p class="text-muted mt-2 mb-0">Cargando lista…</p>
    </div>

    <div v-else-if="!items.length" class="lista-compra-empty text-center py-5">
      <i class="bi bi-bag fs-1 d-block mb-2 text-success"></i>
      <p class="mb-2">La lista está vacía.</p>
      <p class="text-muted small mb-3">
        Añade cosas a mano o genera los ingredientes de los próximos días de Nutrición.
      </p>
      <div class="d-flex gap-2 justify-content-center flex-wrap">
        <button class="btn btn-success" type="button" :disabled="generando" @click="pedirConfirmacion('anadirMenu')">
          <i class="bi bi-egg-fried me-1"></i>Generar desde el menú
        </button>
        <router-link class="btn btn-outline-success" to="/nutricion?from=lista">
          <i class="bi bi-calendar-week me-1"></i>Ver menú
        </router-link>
      </div>
    </div>

    <div v-else class="lista-compra-grupos">
      <section v-if="pendientesItems.length">
        <h3 class="lista-compra-grupo-titulo">
          <span>Por comprar</span>
          <span class="lista-compra-grupo-cuenta" :aria-label="`${pendientes} pendientes`">
            {{ pendientes }}
          </span>
        </h3>
        <ul class="lista-compra-lista">
          <li v-for="item in pendientesItems" :key="item.id">
            <button
              type="button"
              class="lista-compra-item"
              @click="toggleItem(item)"
            >
              <span class="lista-compra-check" aria-hidden="true"></span>
              <span class="lista-compra-texto">
                <span class="lista-compra-nombre">{{ item.nombre }}</span>
                <span
                  v-for="(uso, idx) in usosItem(item)"
                  :key="`${item.id}-uso-${idx}`"
                  class="lista-compra-plato"
                >{{ uso }}</span>
                <span v-if="!usosItem(item).length && etiquetaOrigenItem(item)" class="lista-compra-plato">
                  {{ etiquetaOrigenItem(item) }}
                </span>
              </span>
              <span class="lista-compra-meta">
                <span class="lista-compra-quien">{{ etiquetaAnadidoPor(item) }}</span>
                <span class="lista-compra-cuando">{{ formatoFechaAnadido(item.createdAt) }}</span>
              </span>
            </button>
            <button
              type="button"
              class="lista-compra-despensa"
              title="Pasar a despensa: no se volverá a añadir del menú"
              @click="pasarADespensa(item)"
            >
              <i class="bi bi-archive"></i>
            </button>
            <button
              type="button"
              class="lista-compra-borrar"
              title="Quitar"
              @click="borrarItem(item)"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </li>
        </ul>
      </section>

      <section v-if="tachados.length" class="mt-4">
        <button
          type="button"
          class="lista-compra-grupo-titulo lista-compra-grupo-toggle"
          :aria-expanded="mostrarTachados.toString()"
          @click="mostrarTachados = !mostrarTachados"
        >
          <span>En el carro</span>
          <span class="lista-compra-grupo-cuenta lista-compra-grupo-cuenta--muted">
            {{ tachados.length }}
          </span>
          <i class="bi ms-auto" :class="mostrarTachados ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        </button>
        <ul v-show="mostrarTachados" class="lista-compra-lista">
          <li v-for="item in tachados" :key="item.id">
            <button
              type="button"
              class="lista-compra-item lista-compra-item--done"
              @click="toggleItem(item)"
            >
              <span class="lista-compra-check lista-compra-check--on" aria-hidden="true">
                <i class="bi bi-check-lg"></i>
              </span>
              <span class="lista-compra-texto">
                <span class="lista-compra-nombre">{{ item.nombre }}</span>
                <span
                  v-for="(uso, idx) in usosItem(item)"
                  :key="`${item.id}-done-uso-${idx}`"
                  class="lista-compra-plato"
                >{{ uso }}</span>
                <span v-if="item.checkedBy" class="lista-compra-plato">
                  Tachado por {{ item.checkedBy }}
                </span>
              </span>
              <span class="lista-compra-meta">
                <span class="lista-compra-quien">{{ etiquetaAnadidoPor(item) }}</span>
                <span class="lista-compra-cuando">{{ formatoFechaAnadido(item.createdAt) }}</span>
              </span>
            </button>
            <button
              type="button"
              class="lista-compra-borrar"
              title="Quitar"
              @click="borrarItem(item)"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </li>
        </ul>
      </section>
    </div>

    <div v-if="snack" class="lista-snack" role="status">
      <span class="lista-snack-texto">{{ snack }}</span>
      <button type="button" class="lista-snack-btn" :disabled="deshaciendo" @click="deshacer">
        Deshacer
      </button>
    </div>

    <button
      v-if="puedeDeshacer && !snack"
      type="button"
      class="lista-undo-fab"
      :disabled="deshaciendo"
      @click="deshacer"
    >
      <span v-if="deshaciendo" class="spinner-border spinner-border-sm"></span>
      <i v-else class="bi bi-arrow-counterclockwise"></i>
      <span>Deshacer{{ ultimaAccion ? ` ${ultimaAccion}` : '' }}</span>
    </button>

    <div v-if="confirmacion" class="lista-confirm" role="dialog" aria-modal="true" @click.self="cerrarConfirmacion">
      <div class="lista-confirm-card">
        <h3 class="lista-confirm-titulo">{{ confirmacion.titulo }}</h3>
        <p class="lista-confirm-texto">{{ confirmacion.mensaje }}</p>
        <div v-if="confirmacion.pideDesde" class="lista-confirm-desde">
          <p class="lista-confirm-desde-label">¿Desde qué día?</p>
          <p class="lista-confirm-desde-ayuda">
            Así no se añaden ingredientes de comidas que ya tienes compradas.
          </p>
          <div v-if="cargandoDiasMenu" class="lista-confirm-desde-estado">
            <span class="spinner-border spinner-border-sm me-1"></span>
            Cargando menú…
          </div>
          <p v-else-if="errorDiasMenu" class="lista-confirm-desde-error">{{ errorDiasMenu }}</p>
          <div v-else class="lista-confirm-dias" role="radiogroup" aria-label="Día de inicio">
            <label
              v-for="dia in diasMenu"
              :key="dia.fecha"
              class="lista-confirm-dia"
              :class="{ 'lista-confirm-dia--on': desdeFecha === dia.fecha }"
            >
              <input
                v-model="desdeFecha"
                type="radio"
                name="desde-menu-dia"
                :value="dia.fecha"
              />
              <span>
                <strong>{{ etiquetaDiaMenu(dia, hoyMenu) }}</strong>
                <small v-if="resumenPlatosDia(dia)">{{ resumenPlatosDia(dia) }}</small>
              </span>
            </label>
          </div>
        </div>
        <div class="lista-confirm-acciones">
          <button type="button" class="btn btn-outline-secondary" @click="cerrarConfirmacion">
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-success"
            :disabled="confirmacion.pideDesde && !puedeConfirmarDesde"
            @click="aceptarConfirmacion"
          >
            {{ confirmacion.confirmar }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import axios from '@/config/axios';
import {
  etiquetaOrigenItem,
  etiquetaAnadidoPor,
  formatoFechaAnadido,
  usosItem,
  etiquetaDiaMenu,
  resumenPlatosDia,
} from '@/utils/listaCompraEtiquetas';
import {
  leerPreferenciaCompacta,
  guardarPreferenciaCompacta,
  tachadosAbiertosPorDefecto,
} from '@/utils/listaCompraCompacta';

const CONFIRMACIONES = {
  anadirMenu: {
    titulo: 'Añadir del menú',
    mensaje: 'Se añadirán los ingredientes de las recetas desde el día que elijas. Especias y lo que tengas en Despensa no se añaden: si se acaban, ponlos a mano.',
    confirmar: 'Añadir',
    pideDesde: true,
  },
  regenerarMenu: {
    titulo: 'Regenerar menú',
    mensaje: 'Se sustituyen los ingredientes del menú que aún no hayas tachado, a partir del día que elijas. Especias y Despensa siguen sin añadirse. Esta acción se puede deshacer.',
    confirmar: 'Regenerar',
    pideDesde: true,
  },
  limpiar: {
    titulo: 'Quitar tachados',
    mensaje: 'Se eliminarán de la lista todos los alimentos tachados. Puedes deshacerlo después.',
    confirmar: 'Quitar',
  },
  destachar: {
    titulo: 'Destachar todo',
    mensaje: 'Se destacharán todos los alimentos de la lista. Puedes deshacerlo después.',
    confirmar: 'Destachar',
  },
};

const POLL_MS = 2000;

export default {
  name: 'ListaCompra',
  setup() {
    const items = ref([]);
    const revision = ref('');
    const cargando = ref(false);
    const guardando = ref(false);
    const generando = ref(false);
    const limpiando = ref(false);
    const error = ref('');
    const aviso = ref('');
    const snack = ref('');
    const sinIngredientes = ref([]);
    const omitidos = ref([]);
    const omitidosDespensa = ref([]);
    const puedeDeshacer = ref(false);
    const ultimaAccion = ref('');
    const deshaciendo = ref(false);
    const confirmacion = ref(null);
    const diasMenu = ref([]);
    const hoyMenu = ref('');
    const desdeFecha = ref('');
    const cargandoDiasMenu = ref(false);
    const errorDiasMenu = ref('');
    const nuevoNombre = ref('');
    const sugerencias = ref([]);
    const panelSugerencias = ref(false);
    const indiceSugerencia = ref(-1);
    const sugCargando = ref(false);
    const fijos = ref([]);
    const mostrarFijos = ref(false);
    const nuevoFijo = ref('');
    const guardandoFijo = ref(false);
    const despensa = ref([]);
    const mostrarDespensa = ref(false);
    const nuevaDespensa = ref('');
    const guardandoDespensa = ref(false);
    const sincronizado = ref(false);
    const textoSync = ref('Sin sincronizar');
    const compacta = ref(leerPreferenciaCompacta());
    const mostrarTachados = ref(tachadosAbiertosPorDefecto(compacta.value));
    let pollTimer = null;
    let pollInFlight = false;
    let avisoTimer = null;
    let snackTimer = null;
    let sugTimer = null;
    let blurTimer = null;
    let sugSeq = 0;
    const busyIds = new Set();

    const PALABRAS_IGNORADAS = new Set([
      'de', 'del', 'la', 'el', 'los', 'las', 'un', 'una', 'unos', 'unas', 'y', 'con', 'en', 'para',
      'kg', 'kilo', 'kilos', 'g', 'gr', 'gramos', 'l', 'litro', 'litros', 'ml', 'cl',
      'docena', 'docenas', 'paquete', 'paquetes', 'bolsa', 'bolsas', 'bote', 'botes',
      'lata', 'latas', 'botella', 'botellas', 'caja', 'cajas', 'pack', 'tarro', 'tarros',
      'bandeja', 'bandejas', 'ud', 'uds', 'unidad', 'unidades',
    ]);

    function singular(palabra) {
      if (palabra.length > 4 && palabra.endsWith('es') && /[lnrsdz]es$/.test(palabra)) {
        return palabra.slice(0, -2);
      }
      if (palabra.length > 3 && palabra.endsWith('s')) return palabra.slice(0, -1);
      return palabra;
    }

    // Clave de agrupación: primera palabra significativa del nombre (sin tildes,
    // cantidades ni unidades, en singular) para que "huevos" y "docena de huevos" queden juntos.
    function claveAgrupacion(nombre) {
      const palabras = String(nombre || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .split(/[^a-z0-9ñ]+/)
        .filter((w) => w && !/^\d+$/.test(w) && !PALABRAS_IGNORADAS.has(w));
      return palabras.length ? singular(palabras[0]) : String(nombre || '').toLowerCase();
    }

    const pendientesItems = computed(() => {
      const conClave = items.value
        .filter((i) => !i.checked)
        .map((item, idx) => ({ item, idx, clave: claveAgrupacion(item.nombre) }));
      conClave.sort((a, b) => a.clave.localeCompare(b.clave, 'es') || a.idx - b.idx);
      return conClave.map((x) => x.item);
    });
    const tachados = computed(() => items.value.filter((i) => i.checked));
    const pendientes = computed(() => pendientesItems.value.length);
    const sugerenciasVisibles = computed(() => {
      const raw = nuevoNombre.value.trim().toLowerCase();
      if (!raw) return sugerencias.value;
      return sugerencias.value.filter((s) => String(s.nombre || '').toLowerCase().includes(raw));
    });

    function alternarCompacta() {
      compacta.value = !compacta.value;
      guardarPreferenciaCompacta(compacta.value);
      mostrarTachados.value = tachadosAbiertosPorDefecto(compacta.value);
    }

    function mostrarAviso(texto) {
      aviso.value = texto;
      if (avisoTimer) clearTimeout(avisoTimer);
      avisoTimer = setTimeout(() => {
        aviso.value = '';
      }, 4000);
    }

    function mostrarSnack(texto) {
      snack.value = texto;
      if (snackTimer) clearTimeout(snackTimer);
      snackTimer = setTimeout(() => {
        snack.value = '';
      }, 7000);
    }

    function aplicarLista(data, { respetarBusy = false } = {}) {
      if (!data) return;
      if (data.puedeDeshacer != null) puedeDeshacer.value = !!data.puedeDeshacer;
      if (data.ultimaAccion != null) ultimaAccion.value = data.ultimaAccion;
      if (Array.isArray(data.fijos)) fijos.value = data.fijos;
      if (Array.isArray(data.despensa)) despensa.value = data.despensa;
      if (
        data.unchanged
        || !data.items
        || (data.revision && data.revision === revision.value)
        || (respetarBusy && busyIds.size)
      ) {
        sincronizado.value = true;
        textoSync.value = 'Al día';
        return;
      }
      items.value = data.items.map((i) => ({ ...i, _busy: false }));
      revision.value = data.revision || '';
      sincronizado.value = true;
      textoSync.value = 'Al día';
    }

    async function cargarFijos() {
      try {
        const { data } = await axios.get('/api/lista-compra/fijos');
        fijos.value = data.fijos || [];
      } catch {
        fijos.value = [];
      }
    }

    async function anadirFijo() {
      const nombre = nuevoFijo.value.trim();
      if (!nombre || guardandoFijo.value) return;
      guardandoFijo.value = true;
      try {
        const { data } = await axios.post('/api/lista-compra/fijos', { nombre });
        fijos.value = [...fijos.value, data];
        nuevoFijo.value = '';
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudo guardar el ítem de siempre';
      } finally {
        guardandoFijo.value = false;
      }
    }

    async function renombrarFijo(fijo, nombre) {
      const validado = String(nombre || '').trim();
      if (!validado || validado === fijo.nombre) return;
      try {
        const { data } = await axios.patch(`/api/lista-compra/fijos/${fijo.id}`, { nombre: validado });
        fijos.value = fijos.value.map((f) => (f.id === fijo.id ? data : f));
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudo renombrar';
      }
    }

    async function borrarFijo(fijo) {
      try {
        await axios.delete(`/api/lista-compra/fijos/${fijo.id}`);
        fijos.value = fijos.value.filter((f) => f.id !== fijo.id);
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudo borrar el ítem de siempre';
      }
    }

    async function cargarDespensa() {
      try {
        const { data } = await axios.get('/api/lista-compra/despensa');
        despensa.value = data.despensa || [];
      } catch {
        despensa.value = [];
      }
    }

    async function anadirDespensa() {
      const nombre = nuevaDespensa.value.trim();
      if (!nombre || guardandoDespensa.value) return;
      guardandoDespensa.value = true;
      try {
        const { data } = await axios.post('/api/lista-compra/despensa', { nombre });
        despensa.value = [...despensa.value, data];
        nuevaDespensa.value = '';
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudo guardar en despensa';
      } finally {
        guardandoDespensa.value = false;
      }
    }

    async function renombrarDespensa(item, nombre) {
      const validado = String(nombre || '').trim();
      if (!validado || validado === item.nombre) return;
      try {
        const { data } = await axios.patch(`/api/lista-compra/despensa/${item.id}`, { nombre: validado });
        despensa.value = despensa.value.map((d) => (d.id === item.id ? data : d));
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudo renombrar';
      }
    }

    async function borrarDespensa(item) {
      try {
        await axios.delete(`/api/lista-compra/despensa/${item.id}`);
        despensa.value = despensa.value.filter((d) => d.id !== item.id);
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudo borrar de la despensa';
      }
    }

    async function pasarADespensa(item) {
      if (!item || busyIds.has(item.id)) return;
      busyIds.add(item.id);
      try {
        const { data } = await axios.post(`/api/lista-compra/items/${item.id}/despensa`);
        aplicarLista(data);
        if (Array.isArray(data.despensa)) despensa.value = data.despensa;
        mostrarAviso(
          data.movido
            ? `${data.movido} pasa a despensa. Si se acaba, añádelo a mano.`
            : 'Guardado en despensa. Ya no se añadirá del menú.'
        );
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudo pasar a despensa';
      } finally {
        busyIds.delete(item.id);
      }
    }

    async function cargarLista({ silencioso = false } = {}) {
      if (pollInFlight) return;
      pollInFlight = true;
      if (!silencioso && !items.value.length) cargando.value = true;
      try {
        const { data } = await axios.get('/api/lista-compra', {
          params: revision.value ? { revision: revision.value } : undefined,
        });
        aplicarLista(data, { respetarBusy: silencioso });
        if (!silencioso) {
          if (!Array.isArray(data.fijos)) await cargarFijos();
          if (!Array.isArray(data.despensa)) await cargarDespensa();
        }
        error.value = '';
      } catch (e) {
        if (!silencioso) {
          error.value = e.response?.data?.error || 'No se pudo cargar la lista';
        }
        sincronizado.value = false;
        textoSync.value = 'Reintentando…';
      } finally {
        cargando.value = false;
        pollInFlight = false;
      }
    }

    async function cargarSugerencias() {
      const seq = ++sugSeq;
      const q = nuevoNombre.value.trim();
      sugCargando.value = true;
      try {
        const { data } = await axios.get('/api/lista-compra/sugerencias', {
          params: { q }
        });
        if (seq !== sugSeq) return;
        sugerencias.value = data.sugerencias || [];
        if (indiceSugerencia.value >= sugerenciasVisibles.value.length) {
          indiceSugerencia.value = -1;
        }
      } catch {
        if (seq !== sugSeq) return;
        sugerencias.value = [];
      } finally {
        if (seq === sugSeq) sugCargando.value = false;
      }
    }

    function onInputNuevo() {
      panelSugerencias.value = true;
      if (sugTimer) clearTimeout(sugTimer);
      sugTimer = setTimeout(cargarSugerencias, 250);
    }

    function onFocusNuevo() {
      panelSugerencias.value = true;
      cargarSugerencias();
    }

    function cerrarSugerenciasLuego() {
      if (blurTimer) clearTimeout(blurTimer);
      blurTimer = setTimeout(() => {
        panelSugerencias.value = false;
        indiceSugerencia.value = -1;
      }, 120);
    }

    function onKeydownNuevo(e) {
      if (e.key === 'Escape') {
        panelSugerencias.value = false;
        indiceSugerencia.value = -1;
        return;
      }
      if (!panelSugerencias.value || !sugerenciasVisibles.value.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        indiceSugerencia.value = (indiceSugerencia.value + 1) % sugerenciasVisibles.value.length;
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        indiceSugerencia.value =
          (indiceSugerencia.value - 1 + sugerenciasVisibles.value.length) %
          sugerenciasVisibles.value.length;
      } else if (e.key === 'Enter' && indiceSugerencia.value >= 0) {
        e.preventDefault();
        elegirSugerencia(sugerenciasVisibles.value[indiceSugerencia.value]);
      }
    }

    function registrarSugerenciaLocal(nombre, origen) {
      const key = String(nombre).trim().toLowerCase();
      const idx = sugerencias.value.findIndex((s) => String(s.nombre).toLowerCase() === key);
      if (idx >= 0) {
        const actual = sugerencias.value[idx];
        sugerencias.value = [
          { ...actual, veces: (actual.veces || 0) + 1 },
          ...sugerencias.value.filter((_, i) => i !== idx)
        ];
        return;
      }
      sugerencias.value = [{ nombre, veces: 1, origen: origen || 'manual' }, ...sugerencias.value];
    }

    async function elegirSugerencia(sug) {
      if (!sug || !sug.nombre) return;
      nuevoNombre.value = sug.nombre;
      panelSugerencias.value = false;
      indiceSugerencia.value = -1;
      await anadirItem();
    }

    async function anadirItem() {
      const nombre = nuevoNombre.value.trim();
      if (!nombre || guardando.value) return;
      guardando.value = true;
      error.value = '';
      panelSugerencias.value = false;
      try {
        const { data } = await axios.post('/api/lista-compra/items', { nombre });
        nuevoNombre.value = '';
        indiceSugerencia.value = -1;
        items.value = [...items.value, { ...data, _busy: false }];
        revision.value = '';
        puedeDeshacer.value = true;
        ultimaAccion.value = 'añadir';
        registrarSugerenciaLocal(nombre, data.origen || 'manual');
        await cargarLista({ silencioso: true });
      } catch (e) {
        if (e.response?.status === 409 && e.response?.data?.yaExiste) {
          mostrarAviso(e.response.data.error || 'Ya está en la lista');
          nuevoNombre.value = '';
          indiceSugerencia.value = -1;
        } else {
          error.value = e.response?.data?.error || 'No se pudo añadir';
        }
      } finally {
        guardando.value = false;
      }
    }

    async function toggleItem(item) {
      if (busyIds.has(item.id)) return;
      busyIds.add(item.id);
      const siguiente = !item.checked;
      item.checked = siguiente;
      try {
        const { data } = await axios.patch(`/api/lista-compra/items/${item.id}`, {
          checked: siguiente
        });
        const live = items.value.find((x) => x.id === item.id);
        if (live) Object.assign(live, data, { _busy: false });
        revision.value = '';
        puedeDeshacer.value = true;
        ultimaAccion.value = siguiente ? 'tachar' : 'destachar';
        mostrarSnack(`«${item.nombre}» ${siguiente ? 'tachado' : 'destachado'}`);
      } catch (e) {
        const live = items.value.find((x) => x.id === item.id) || item;
        live.checked = !siguiente;
        live._busy = false;
        error.value = e.response?.data?.error || 'No se pudo tachar';
      } finally {
        busyIds.delete(item.id);
      }
    }

    async function borrarItem(item) {
      try {
        await axios.delete(`/api/lista-compra/items/${item.id}`);
        items.value = items.value.filter((i) => i.id !== item.id);
        revision.value = '';
        puedeDeshacer.value = true;
        ultimaAccion.value = 'borrar';
        mostrarSnack(`«${item.nombre}» quitado`);
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudo borrar';
      }
    }

    const puedeConfirmarDesde = computed(() => {
      if (cargandoDiasMenu.value || errorDiasMenu.value) return false;
      return Boolean(desdeFecha.value) && diasMenu.value.some((d) => d.fecha === desdeFecha.value);
    });

    async function cargarDiasMenu() {
      cargandoDiasMenu.value = true;
      errorDiasMenu.value = '';
      diasMenu.value = [];
      try {
        const { data } = await axios.get('/api/lista-compra/dias-menu');
        hoyMenu.value = data.hoy || '';
        diasMenu.value = Array.isArray(data.dias) ? data.dias : [];
        desdeFecha.value = diasMenu.value[0]?.fecha || hoyMenu.value || '';
        if (!diasMenu.value.length) {
          errorDiasMenu.value = 'No hay menú activo para los próximos días. Acéptalo primero en Nutrición.';
        }
      } catch (e) {
        errorDiasMenu.value = e.response?.data?.error || 'No se pudieron cargar los días del menú';
      } finally {
        cargandoDiasMenu.value = false;
      }
    }

    function pedirConfirmacion(clave) {
      const cfg = CONFIRMACIONES[clave];
      if (!cfg) return;
      confirmacion.value = { ...cfg, clave };
      if (cfg.pideDesde) cargarDiasMenu();
    }

    function cerrarConfirmacion() {
      confirmacion.value = null;
    }

    async function aceptarConfirmacion() {
      const clave = confirmacion.value?.clave;
      const fechaInicio = desdeFecha.value;
      if (confirmacion.value?.pideDesde && !puedeConfirmarDesde.value) return;
      confirmacion.value = null;
      if (clave === 'anadirMenu') await generarDesdeMenu(false, fechaInicio);
      else if (clave === 'regenerarMenu') await generarDesdeMenu(true, fechaInicio);
      else if (clave === 'limpiar') await limpiarTachados();
      else if (clave === 'destachar') await desmarcarTodos();
    }

    async function generarDesdeMenu(reemplazarMenu, fechaInicio) {
      generando.value = true;
      error.value = '';
      try {
        const { data } = await axios.post('/api/lista-compra/desde-menu', {
          reemplazarMenu,
          desdeFecha: fechaInicio || undefined,
        });
        aplicarLista(data);
        const n = data.anadidos || 0;
        const partes = [];
        if (data.anadidosMenu) partes.push(`${data.anadidosMenu} del menú`);
        if (data.anadidosFijos) partes.push(`${data.anadidosFijos} de siempre`);
        if (data.actualizados) partes.push(`${data.actualizados} unidos a lo que ya había`);
        const diaElegido = diasMenu.value.find((d) => d.fecha === (data.desdeFecha || fechaInicio));
        const desdeTxt = diaElegido ? etiquetaDiaMenu(diaElegido, hoyMenu.value) : '';
        if (n === 0 && data.actualizados) {
          mostrarAviso(
            `Se han juntado ${data.actualizados} ingredientes que ya estaban en la lista.`
          );
        } else if (n === 0) {
          mostrarAviso('Nada nuevo: esos ingredientes ya estaban en la lista.');
        } else {
          const extra = desdeTxt
            ? `${data.diasUsados} días desde ${desdeTxt}`
            : `${data.diasUsados} días`;
          mostrarAviso(
            reemplazarMenu
              ? `Lista regenerada: ${partes.join(' y ')} (${extra}).`
              : `Añadidos ${partes.join(' y ')} (${extra}).`
          );
        }
        sinIngredientes.value = data.sinIngredientes || [];
        omitidos.value = data.omitidos || [];
        omitidosDespensa.value = data.omitidosDespensa || [];
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudo generar desde el menú';
      } finally {
        generando.value = false;
      }
    }

    async function limpiarTachados() {
      limpiando.value = true;
      try {
        const { data } = await axios.post('/api/lista-compra/limpiar-tachados');
        aplicarLista(data);
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudieron quitar los tachados';
      } finally {
        limpiando.value = false;
      }
    }

    async function desmarcarTodos() {
      try {
        const { data } = await axios.post('/api/lista-compra/desmarcar');
        aplicarLista(data);
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudo destachar';
      }
    }

    async function deshacer() {
      if (deshaciendo.value || !puedeDeshacer.value) return;
      deshaciendo.value = true;
      error.value = '';
      try {
        const { data } = await axios.post('/api/lista-compra/deshacer');
        aplicarLista(data);
        puedeDeshacer.value = !!data.puedeDeshacer;
        ultimaAccion.value = data.ultimaAccion || '';
        snack.value = '';
        mostrarAviso(data.accion ? `Deshecho: ${data.accion}` : 'Última acción deshecha');
      } catch (e) {
        error.value = e.response?.data?.error || 'No se pudo deshacer';
        if (e.response?.status === 400) {
          puedeDeshacer.value = false;
          ultimaAccion.value = '';
        }
      } finally {
        deshaciendo.value = false;
      }
    }

    function onKeydownGlobal(e) {
      if (e.key === 'Escape' && confirmacion.value) {
        cerrarConfirmacion();
      }
    }

    function onVisibilidad() {
      if (document.hidden) {
        if (pollTimer) {
          clearInterval(pollTimer);
          pollTimer = null;
        }
      } else {
        cargarLista({ silencioso: true });
        arrancarPolling();
      }
    }

    function arrancarPolling() {
      if (pollTimer) return;
      pollTimer = setInterval(() => {
        if (!document.hidden) cargarLista({ silencioso: true });
      }, POLL_MS);
    }

    onMounted(() => {
      cargarLista();
      arrancarPolling();
      document.addEventListener('visibilitychange', onVisibilidad);
      document.addEventListener('keydown', onKeydownGlobal);
    });

    onUnmounted(() => {
      if (pollTimer) clearInterval(pollTimer);
      if (avisoTimer) clearTimeout(avisoTimer);
      if (snackTimer) clearTimeout(snackTimer);
      if (sugTimer) clearTimeout(sugTimer);
      if (blurTimer) clearTimeout(blurTimer);
      document.removeEventListener('visibilitychange', onVisibilidad);
      document.removeEventListener('keydown', onKeydownGlobal);
    });

    return {
      items,
      pendientesItems,
      tachados,
      pendientes,
      cargando,
      guardando,
      generando,
      limpiando,
      error,
      aviso,
      snack,
      etiquetaOrigenItem,
      etiquetaAnadidoPor,
      formatoFechaAnadido,
      usosItem,
      sinIngredientes,
      omitidos,
      omitidosDespensa,
      puedeDeshacer,
      ultimaAccion,
      deshaciendo,
      confirmacion,
      diasMenu,
      hoyMenu,
      desdeFecha,
      cargandoDiasMenu,
      errorDiasMenu,
      puedeConfirmarDesde,
      etiquetaDiaMenu,
      resumenPlatosDia,
      pedirConfirmacion,
      cerrarConfirmacion,
      aceptarConfirmacion,
      deshacer,
      nuevoNombre,
      sugerencias,
      sugerenciasVisibles,
      panelSugerencias,
      indiceSugerencia,
      sugCargando,
      onInputNuevo,
      onFocusNuevo,
      onKeydownNuevo,
      cerrarSugerenciasLuego,
      elegirSugerencia,
      fijos,
      mostrarFijos,
      nuevoFijo,
      guardandoFijo,
      anadirFijo,
      renombrarFijo,
      borrarFijo,
      despensa,
      mostrarDespensa,
      nuevaDespensa,
      guardandoDespensa,
      anadirDespensa,
      renombrarDespensa,
      borrarDespensa,
      pasarADespensa,
      sincronizado,
      textoSync,
      compacta,
      mostrarTachados,
      alternarCompacta,
      anadirItem,
      toggleItem,
      borrarItem,
      generarDesdeMenu,
      limpiarTachados,
      desmarcarTodos
    };
  }
};
</script>

<style scoped>
.lista-compra-page {
  max-width: 42rem;
  padding-bottom: 7.5rem;
}

.lista-ver-menu {
  font-weight: 600;
}

.sync-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  color: #6c7a6e;
  background: #eef3ee;
  border-radius: 999px;
  padding: 0.2rem 0.65rem;
}

.sync-pill--live {
  color: #146c2e;
  background: #d9f0df;
}

.lista-compra-add-wrap {
  position: relative;
}

.lista-compra-sugerencias {
  position: absolute;
  z-index: 30;
  left: 0;
  right: 0;
  top: calc(100% + 0.3rem);
  max-height: 16rem;
  overflow-y: auto;
  border-radius: 0.85rem;
}

.lista-compra-sugerencias .list-group-item {
  border-color: #d7e3d8;
  color: #1d2a20;
}

.lista-compra-sugerencias .list-group-item.active {
  background: #2f7d46;
  border-color: #2f7d46;
  color: #fff;
}

.lista-compra-add .form-control {
  font-size: 1.05rem;
}

.lista-siempre {
  background: #eef6ef;
  border-radius: 0.9rem;
}

.lista-despensa {
  background: #f4f1ea;
}

.lista-siempre-toggle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0;
  background: transparent;
  padding: 0.7rem 0.9rem;
  font-weight: 600;
  color: #1d2a20;
}

.lista-siempre-body {
  padding: 0 0.9rem 0.9rem;
}

.lista-siempre-lista {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.lista-siempre-lista > li {
  display: flex;
  gap: 0.3rem;
  align-items: center;
}

.lista-compra-grupo-titulo {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #5d6b60;
  margin-bottom: 0.5rem;
}

.lista-compra-grupo-toggle {
  width: 100%;
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
}

.lista-compra-grupo-cuenta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.4rem;
  border-radius: 999px;
  background: #2f7d46;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  line-height: 1;
}

.lista-compra-grupo-cuenta--muted {
  background: #d7e0d8;
  color: #3d4b40;
}

.lista-compacta-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid #c9d6cb;
  background: #fff;
  color: #3d4b40;
  border-radius: 999px;
  padding: 0.28rem 0.7rem;
  font-size: 0.8rem;
  font-weight: 600;
}

.lista-compacta-toggle--on {
  background: #2f7d46;
  border-color: #2f7d46;
  color: #fff;
}

.lista-compra-lista {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.lista-compra-lista > li {
  display: flex;
  align-items: stretch;
  gap: 0.35rem;
}

.lista-compra-item {
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  text-align: left;
  border: 1px solid #d7e3d8;
  background: #f7fbf7;
  border-radius: 0.9rem;
  padding: 0.85rem 0.95rem;
  min-height: 3.4rem;
}

.lista-compra-item--done {
  background: #f3f4f3;
  border-color: #e1e4e1;
}

.lista-compra-check {
  width: 1.7rem;
  height: 1.7rem;
  border: 2px solid #2f7d46;
  border-radius: 0.45rem;
  flex: 0 0 auto;
  margin-top: 0.1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.lista-compra-check--on {
  background: #2f7d46;
  color: #fff;
}

.lista-compra-texto {
  flex: 1;
  min-width: 0;
}

.lista-compra-nombre {
  display: block;
  font-weight: 600;
  color: #1d2a20;
}

.lista-compra-item--done .lista-compra-nombre {
  text-decoration: line-through;
  color: #7a847c;
  font-weight: 500;
}

.lista-compra-plato {
  display: block;
  font-size: 0.78rem;
  color: #6b776e;
  margin-top: 0.15rem;
}

.lista-compra-meta {
  flex: 0 0 auto;
  text-align: right;
  margin-left: auto;
  padding-left: 0.4rem;
  max-width: 7.8rem;
  line-height: 1.25;
}

.lista-compra-quien {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  color: #4a5a4e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lista-compra-cuando {
  display: block;
  font-size: 0.7rem;
  color: #7a847c;
}

.lista-compra-item--done .lista-compra-quien,
.lista-compra-item--done .lista-compra-cuando {
  color: #8a938c;
  font-weight: 500;
}

.lista-compra-borrar,
.lista-compra-despensa {
  border: 0;
  background: transparent;
  color: #8a938c;
  padding: 0 0.45rem;
  border-radius: 0.6rem;
}

.lista-compra-empty {
  border: 1px dashed #c9d6cb;
  border-radius: 1rem;
  background: #f7fbf7;
}

.lista-undo-cabecera {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 0;
  background: #1d2a20;
  color: #fff;
  border-radius: 999px;
  padding: 0.28rem 0.7rem;
  font-size: 0.8rem;
  font-weight: 600;
}

.lista-snack {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: max(1.15rem, env(safe-area-inset-bottom));
  z-index: 1035;
  display: flex;
  align-items: center;
  gap: 0.9rem;
  max-width: calc(100vw - 2rem);
  padding: 0.6rem 0.75rem 0.6rem 1.1rem;
  border-radius: 999px;
  background: #1d2a20;
  color: #fff;
  box-shadow: 0 10px 24px rgba(29, 42, 32, 0.28);
}

.lista-snack-texto {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lista-snack-btn {
  border: 0;
  background: transparent;
  color: #8fe0a6;
  font-weight: 700;
  padding: 0.2rem 0.5rem;
}

@media (max-width: 991.98px) {
  .lista-snack {
    bottom: calc(var(--app-tabbar-offset) + 0.75rem);
  }
}

.lista-undo-fab {
  position: fixed;
  right: max(1rem, env(safe-area-inset-right));
  bottom: max(1.15rem, env(safe-area-inset-bottom));
  z-index: 1030;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-height: 3.1rem;
  padding: 0.7rem 1.15rem;
  border: 0;
  border-radius: 999px;
  background: #1d2a20;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 10px 24px rgba(29, 42, 32, 0.28);
}

.lista-confirm {
  position: fixed;
  inset: 0;
  z-index: 1055;
  background: rgba(16, 24, 18, 0.45);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 1rem;
}

.lista-confirm-card {
  width: min(100%, 26rem);
  background: #fff;
  border-radius: 1rem 1rem 0.75rem 0.75rem;
  padding: 1.15rem 1.1rem 1.2rem;
  box-shadow: 0 16px 40px rgba(16, 24, 18, 0.2);
}

.lista-confirm-titulo {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1d2a20;
  margin: 0 0 0.4rem;
}

.lista-confirm-texto {
  color: #4a5a4e;
  margin: 0 0 1rem;
  font-size: 0.95rem;
}

.lista-confirm-desde {
  margin: 0 0 1rem;
}

.lista-confirm-desde-label {
  margin: 0 0 0.15rem;
  font-weight: 700;
  color: #1d2a20;
}

.lista-confirm-desde-ayuda,
.lista-confirm-desde-estado {
  margin: 0 0 0.65rem;
  font-size: 0.85rem;
  color: #6c7a6e;
}

.lista-confirm-desde-error {
  margin: 0;
  font-size: 0.9rem;
  color: #8a3b12;
}

.lista-confirm-dias {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  max-height: 40vh;
  overflow-y: auto;
  padding-right: 0.15rem;
}

.lista-confirm-dia {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin: 0;
  padding: 0.55rem 0.7rem;
  border: 1px solid #d7e3d8;
  border-radius: 0.75rem;
  cursor: pointer;
}

.lista-confirm-dia input {
  margin-top: 0.2rem;
  accent-color: #2f7d46;
}

.lista-confirm-dia span {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.lista-confirm-dia strong {
  font-size: 0.95rem;
  color: #1d2a20;
}

.lista-confirm-dia small {
  color: #6c7a6e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lista-confirm-dia--on {
  border-color: #2f7d46;
  background: #eef7f0;
}

.lista-confirm-acciones {
  display: flex;
  gap: 0.6rem;
}

.lista-confirm-acciones .btn {
  flex: 1;
  min-height: 2.75rem;
}

@media (max-width: 991.98px) {
  .lista-confirm {
    bottom: var(--app-tabbar-offset);
    padding: 1rem 1rem 0.65rem;
  }

  .lista-confirm-card {
    max-height: calc(100dvh - var(--app-tabbar-offset) - 4.5rem);
    overflow-y: auto;
  }

  .lista-undo-fab {
    bottom: calc(var(--app-tabbar-offset) + 0.75rem);
  }
}

@media (min-width: 576px) {
  .lista-confirm {
    align-items: center;
  }
  .lista-confirm-card {
    border-radius: 1rem;
  }
}

@media (hover: hover) {
  .lista-compra-item:hover {
    border-color: #2f7d46;
  }
  .lista-compra-borrar:hover {
    background: #f0f2f0;
    color: #b42318;
  }
  .lista-compra-despensa:hover {
    background: #f4f1ea;
    color: #6a5420;
  }
  .lista-undo-fab:hover,
  .lista-undo-cabecera:hover {
    background: #146c2e;
  }
  .lista-compacta-toggle:hover {
    border-color: #2f7d46;
  }
}

@media (min-width: 992px) {
  .lista-undo-fab {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .lista-compra-page--compact {
    padding-bottom: 5.5rem;
  }

  .lista-compra-page--compact .lista-compra-extra {
    display: none !important;
  }

  .lista-compra-page--compact .lista-compra-cabecera {
    flex-wrap: nowrap;
    align-items: center;
    gap: 0.5rem;
  }

  .lista-compra-page--compact .lista-compra-titulo {
    font-size: 1.05rem;
    white-space: nowrap;
  }

  .lista-compra-page--compact .lista-compacta-toggle {
    flex-shrink: 0;
    margin-left: auto;
  }

  .lista-compra-page--compact .lista-undo-cabecera {
    display: inline-flex;
    flex-shrink: 0;
    margin-left: auto;
  }

  .lista-compra-page--compact .lista-compra-add {
    margin-bottom: 0.7rem !important;
  }

  .lista-compra-page--compact .lista-compra-add .input-group-lg > .form-control,
  .lista-compra-page--compact .lista-compra-add .input-group-lg > .btn {
    min-height: 2.55rem;
    font-size: 0.95rem;
  }

  .lista-compra-page--compact .lista-compra-grupo-titulo {
    position: sticky;
    top: 0;
    z-index: 8;
    margin-bottom: 0.35rem;
    padding: 0.35rem 0;
    background: #fff;
  }

  .lista-compra-page--compact .lista-compra-lista {
    gap: 0.18rem;
  }

  .lista-compra-page--compact .lista-compra-lista > li {
    gap: 0.15rem;
  }

  .lista-compra-page--compact .lista-compra-item {
    align-items: center;
    gap: 0.55rem;
    padding: 0.4rem 0.6rem;
    min-height: 2.75rem;
    border-radius: 0.55rem;
  }

  .lista-compra-page--compact .lista-compra-check {
    width: 1.25rem;
    height: 1.25rem;
    margin-top: 0;
    border-radius: 0.32rem;
  }

  .lista-compra-page--compact .lista-compra-nombre {
    font-size: 0.95rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .lista-compra-page--compact .lista-compra-plato,
  .lista-compra-page--compact .lista-compra-meta,
  .lista-compra-page--compact .lista-compra-borrar,
  .lista-compra-page--compact .lista-compra-despensa {
    display: none;
  }
}
</style>
